export default __webpack_public_path__ + "static/media/audit.a9bdd94e.jpg";